<template>
    <div class="rounded-2xl border border-gray-200 bg-white p-6 shadow-soft sm:p-8">
        <slot />
    </div>
</template>
